import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://billing.staticcomputersinc.com',
  headers: {
    'x-api-key': 'XXXX-XXXX-XXXX-XXXX',
  },
});

export default axiosInstance;
